import * as React from "react";
import type {Range} from "slate";

export interface ReferenceQuery {
    search: string;
    range: Range | null | undefined;
}

export interface References {
    disabled: boolean;
    setDisabled: React.Dispatch<React.SetStateAction<boolean>>;
    query: ReferenceQuery;
    setQuery: React.Dispatch<React.SetStateAction<ReferenceQuery>>;
    index: number;
    setIndex: React.Dispatch<React.SetStateAction<number>>;
    filteredReferenceList: string[];
    showButton: boolean;
    contexts: string[];
    enabledConfigs: Set<string>;
}

export const ReferencesContext = React.createContext<References>({
    filteredReferenceList: [],
    showButton: false,
    enabledConfigs: new Set<string>(),
    index: 0,
    setIndex: (_: React.SetStateAction<number>): void => {
        throw new Error("Function not implemented.");
    },
    query: {
        search: "",
        range: undefined,
    },
    setQuery: (_: React.SetStateAction<ReferenceQuery>): void => {
        throw new Error("Function not implemented.");
    },
    disabled: true,
    setDisabled: (_: React.SetStateAction<boolean>): void => {
        throw new Error("Function not implemented.");
    },
    contexts: [],
});
